import { Badge } from '@mantine/core';

export function RedFlagWarningCountBadge({ count }: { count?: number }) {
  return (
    <Badge
      circle
      color={count ? 'redBrand.1' : 'grayBrand.1'}
      style={{
        color: count
          ? `var(--os-statusColor-error)`
          : 'var(--os-mainColor-foreground-disabled)',
      }}
    >
      {count ?? 0}
    </Badge>
  );
}
